/** Local shortcut guard only. Destinations and adjacency always come from the server. */
export function navigationIsBlocked(event: KeyboardEvent): boolean {
  return event.defaultPrevented || event.isComposing || event.repeat
    || Boolean(document.querySelector('[role="dialog"], [role="alertdialog"]'))
    || (event.target instanceof Element && Boolean(event.target.closest(
      'input, textarea, select, [contenteditable]:not([contenteditable="false"]), [role="textbox"]',
    )));
}

export function neighbourShortcut(event: KeyboardEvent): "previous_session" | "next_session" | null {
  if (navigationIsBlocked(event) || event.metaKey || event.ctrlKey || event.altKey || event.shiftKey) return null;
  return event.key === "j" ? "next_session" : event.key === "k" ? "previous_session" : null;
}
